// Gradient definitions - centralized for consistency
export const GRADIENTS = {
  primary: {
    neon: 'from-cyan-500 to-pink-500',
    default: 'from-purple-500 to-pink-500',
  },
  background: {
    default: 'from-slate-900 via-purple-900 to-slate-900',
    ocean: 'from-blue-900 via-cyan-900 to-blue-900',
    sunset: 'from-orange-900 via-red-900 to-pink-900',
    forest: 'from-green-900 via-emerald-900 to-teal-900',
    midnight: 'from-gray-900 via-slate-900 to-gray-900',
    aurora: 'from-purple-900 via-pink-900 to-blue-900',
  },
  accent: {
    neon: 'from-cyan-500 via-cyan-400 to-pink-500',
    default: 'from-purple-500 via-purple-400 to-pink-500',
  },
} as const
// Common animation variants
export const ANIMATION_VARIANTS = {
  fadeIn: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
  },
  slideIn: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
  },
} as const
// Common transition configs
export const TRANSITIONS = {
  spring: { type: 'spring', damping: 25, stiffness: 200 },
  smooth: { duration: 0.3, ease: 'easeInOut' },
} as const
